// Navigation des Moduls `home` (eager geladen; Quelle UX §2.2–§2.10). Besitzer: Modul home.
import { House } from '@phosphor-icons/react';
import { defineMeta } from '@web/registry/define';

export default defineMeta({
  key: 'home',
  title: 'Home & Inbox',
  nav: {
    people: [
      {
        key: 'home',
        label: 'Home',
        icon: House,
        path: '/',
        roles: ['ALL'],
        order: 10,
        area: 'rail',
      },
    ],
  },
});
